export default __webpack_public_path__ + "static/media/drag.479dfb8f.PNG";